import { combineReducers } from 'redux'

import contactform from './contactform'

export default combineReducers({
  contactform
})
